import { render, staticRenderFns } from "./contacts_table.vue?vue&type=template&id=6458171d&scoped=true&"
import script from "./contacts_table.vue?vue&type=script&lang=js&"
export * from "./contacts_table.vue?vue&type=script&lang=js&"
import style0 from "./contacts_table.vue?vue&type=style&index=0&id=6458171d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458171d",
  null
  
)

export default component.exports